import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

// Wraps each form so Google reCAPTCHA loads only where a form is shown, not on every page.
const RecaptchaProvider = ({ children }) => (
    <GoogleReCaptchaProvider
        reCaptchaKey="6Lc0_FYlAAAAALtLnlgYbZJSU8xIcM6QektrreVi"
        language="en"
        useEnterprise="false"
    >
        {children}
    </GoogleReCaptchaProvider>
);

export default RecaptchaProvider;
